import type { QSelectProps, QTableColumn } from 'quasar'
import type { User } from 'src/types'
import type { MaybeRef } from 'vue'
import { useStorage } from '@vueuse/core'
import { Screen } from 'quasar'
import { customRef, isRef, unref } from 'vue'
// import type { RouteNamedMap } from 'vue-router/unplugin'

// update the server!
const superAdmins = [
  'lscorionjs@gmail.com',
  'c.verrone@eurocarsystem.com',
  'n.petito@eurocarsystem.com',
  'a.caiazzo@eurocarsystem.com',
]

export const me = computed(() => useAuthStore().user as User)
export const isMe = computed(() => me.value.email === 'lscorionjs@gmail.com')
export const isSuperAdmin = computed(() => superAdmins.includes(me.value.email)) // accede permessi utente
export const employees = computed(() => (useApiStore().forSelect('users') as User[]).filter(i => userTypesEnum.Amministratore !== i.type && !i.piva && !i.automotive))
export const employeesPlusAdmins = computed(() => (useApiStore().forSelect('users') as User[]).filter(i => !i.piva && !i.automotive))
export const employeesPlusAdminsAutomotive = computed(() => (useApiStore().forSelect('users') as User[]).filter(i => !i.piva))
export const brandModels = computed(() => useApiStore().forSelect('brand_models').map(i => ({ ...i, label: `${getBrandLabel(i.id)} ${i.label}` })))
export const activeEmployees = computed(() => employees.value.filter(i => i.active))

export function useUserType() {
  return {
    isCarrozziere: computed(() => userTypesEnum.Carrozziere === me.value.type),
    isAdmin: computed(() => me.value.type === userTypesEnum.Amministratore),
    // vede solo il prezzo tecnico (prezzo - percentuale)
    isLevabolliPiva: computed(() => me.value.type === userTypesEnum.Levabolli && me.value.piva),
  }
}

export function uppercaseRef(value?: string) {
  return customRef((track, trigger) => ({
    get() {
      track()
      return value
    },
    set(newValue?: string) {
      value = newValue?.toUpperCase()
      trigger()
    },
  }))
}

// export const preExcludeOnXs = <Row extends Record<string, any>, K extends keyof Row>(columns: K[], always: K[] = []) => Screen.xs ? [...always,...columns] : always
export function useColumnSelectProps<Row extends Record<string, any>>(
  key: string,
  columns: MaybeRef<QTableColumn<Row>[]>,
  preExcludeOnXs: (keyof Row)[] = [],
  alwaysExclude: (keyof Row)[] = [],
  alwaysInclude: (keyof Row)[] = [],
) {
  const $q = useQuasar()

  const visibleColumns = useStorage(key, [
    ...alwaysInclude,
    ...unref(columns)
      .filter(c => Screen.xs ? (!preExcludeOnXs.includes(c.name) && !alwaysExclude.includes(c.name)) : !alwaysExclude.includes(c.name))
      .map(c => c.name),
  ])

  const requireds = computed(() => (isRef(columns) ? columns.value : columns).filter(c => c.required).length)

  const selectProps = computed((): Omit<QSelectProps, 'modelValue'> => ({
    dense: true,
    multiple: true,
    optionsDense: true,
    hideDropdownIcon: true,
    emitValue: true,
    mapOptions: true,
    options: (isRef(columns) ? columns.value : columns)
      .filter(c => !c.required && !alwaysInclude.includes(c.name))
      .map(c => ({ label: c.label, value: c.name })),
    displayValue: `${$q.screen.xs ? '' : `${$q.lang.table.columns} `}(${visibleColumns.value.length - requireds.value}/${(isRef(columns) ? columns.value : columns).length + alwaysInclude.length - requireds.value})`,
    borderless: true,
    // style="min-width: 80px"
  }))

  return {
    visibleColumns,
    selectProps,
  }
}

export function useChips(chips: readonly { label: string, key: number, color: string }[]) {
  const model = reactive(Object.fromEntries(chips.map(c => [c.key, true])))

  const filter = computed(() => Object.entries(model).filter(([_, v]) => v).map(([k]) => k).join(','))

  return {
    model,
    filter,
  }
}

// type PickSingleViewRoutes<S> = S extends `/${infer R}/[id]` ? `/${R}/[id]` : never

// export function doubleView(name: PickSingleViewRoutes<keyof RouteNamedMap>): Partial<QTableProps> {
// // export const doubleView = computed(()=> (name: PickSingleViewRoutes<keyof RouteNamedMap>): Partial<QTableProps> => {
//   if (isAdmin.value) {
//     const $router = useRouter()
//     console.log('--- ~ doubleView ~ $router:', $router)
//     return {
//       async onRowDblclick(_, row) {
//         await $router.push({ name, params: { id: row.id } })
//       },
//     }
//   }
//   return {}
// }
